import Vue from 'vue';
import ImgsReader from '../../src/vue_components/pictureSwiper.vue'

const imglist = window.cfgs?.imageList || []

// 图片解密
function imgBindClickEvent(className="#articleContent img.content-image") {
    const imgDoms = document.querySelectorAll(className)
    // 绑定点击事件,展示图片预览
    imgDoms.forEach((imgDom)=>{
        imgDom.addEventListener('click', (e) => showPictureMask(e) )
    })
}
// 图片预览&异步加载vue-awesome-swiper
async function showPictureMask(e) {
    try {
        e.preventDefault()
        const imgSrc = e.target?.src
        const imgindex = findImgIndex(imgSrc) || 0
        const swiperObj = await import(/* webpackChunkName: "dynamic4vueAwesomeSwiper" */'vue-awesome-swiper')
        // 首次加载
        if(!document.querySelector('#mySwiper')) {
            const swiperComp = swiperObj.default
            Vue.use(swiperComp)
            new Vue({
                el: '#artImgsReader',
                components: {
                    ImgsReader
                },
                data() {
                    return {
                        imgindex: imgindex
                    }
                },
            })
        }else { // 非首次加载
            window.EVENT_BUS.$emit('showPictureMask',imgindex)
        }
        window.EVENT_BUS.$emit('changeFetchAdFlag',false)
    } catch (error) {
       console.log('图片预览失败',error)
    }
}
// 确定图片的index
function findImgIndex(imgSrc) {
    if(!imgSrc)return 0
    if(!imglist || !imglist.length)return 0

    for(let i = 0; i < imglist.length; i++) {
        if(imgSrc.includes(imglist[i]?.url)) {
            return i
        }
    }

    return 0
}


export { imgBindClickEvent };
